import { createApp } from 'vue';
import SvgToPngConverter from '@/Components/SvgToPngConverter.vue';
import '@styles/app.css';

createApp(SvgToPngConverter).mount('#svg-to-png-converter');
